import Swiper from "swiper";
import(/* webpackPrefetch: true */ "swiper/css/swiper.min.css");

export default { Swiper };
